export default "__VITE_ASSET__CxGgI2dK__"